var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"trunk"}},[_c('lead',{attrs:{"headOption":_vm.headOption}}),_c('main',{staticClass:"main"},[_c('div',{attrs:{"id":"examine"}},[_c('keep-alive',{attrs:{"include":"examineHome"}},[_c('router-view')],1)],1)]),_c('foote')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }